<!-- <div class="card card-tbk"> -->
<div class="card-body-product">
    <!-- <h5 class="card-title">Selecciona una empresa experta</h5> -->
    <span class="card-text-description">Para crear tu tienda online con el soporte de un especialista e integrar
        Webpay como medio de pago,
        selecciona una de
        las siguientes empresas expertas.</span>
    <app-messages class="informativo mt-24 mb-12 p-16" message='Recuerda que tu debes contactar y acordar con el proveedor de servicios
        la implementación en tu sitio web o plataforma.'>
    </app-messages>
    <div class="row">
        <div class="col-md-12">
            <input #buscarPST class="icon--right icon-search" type="text" name="buscarEmpresa"
                placeholder="Buscar Empresa" autocomplete="off" (input)="filterProveedor(buscarPST.value)" />
        </div>
        <div class="col-md-12 pt-12">
            <mat-selection-list #pst>
                <mat-list-item class="pst-list-item" (click)="selectPST(proveedor.idComercio)"
                    [ngClass]="{'mat-list-item-content-selected': selectedPST === proveedor.idComercio}" role="listitem"
                    *ngFor="let proveedor of filteredProveedores">
                    <img matListAvatar [src]="transform(proveedor.imagen)" [alt]="proveedor.nombreFantasia">
                    <h3 class="pst-text-title" matLine>{{proveedor.nombreFantasia}} </h3>
                    <p matLine>
                        <span class="pst-text-description">{{proveedor.descripcion}} </span>
                    </p>
                    <mat-radio-button class="radiobutton-primary-tbk ml-24" [value]="proveedor.idComercio"
                        (change)="selectPST($event.value)" [checked]="selectedPST === proveedor.idComercio">
                    </mat-radio-button>
                </mat-list-item>
                <app-messages *ngIf="filteredProveedores.length == 0" class="advertencia mt-24 mb-12 p-16"
                    message='No se encontraron empresas para el término ingresado.'>
                </app-messages>
            </mat-selection-list>
        </div>
    </div>
</div>
<!-- </div> -->